import { Summary } from '../services/purchaseApi.types';

const WINDOWS_TO_IANA: Record<string, string> = {
  // Mountain (Arizona - No DST)
  'US Mountain Standard Time': 'America/Phoenix',

  // Mountain (With DST)
  'Mountain Standard Time': 'America/Denver',

  // Pacific
  'Pacific Standard Time': 'America/Los_Angeles',

  // Central
  'Central Standard Time': 'America/Chicago',

  // Eastern
  'Eastern Standard Time': 'America/New_York',

  // Alaskan
  'Alaskan Standard Time': 'America/Anchorage',

  // Hawaiian (No DST)
  'Hawaiian Standard Time': 'Pacific/Honolulu'
};

export function getTimeZoneAbbreviation(transfer: Summary['transfer']): string | null {
  if (transfer === undefined) {
    return null;
  }

  const ianaZone = WINDOWS_TO_IANA[transfer.serviceTimeZone];

  if (!ianaZone) {
    return null;
  }

  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: ianaZone,
      timeZoneName: 'short'
    });
    const parts = formatter.formatToParts(new Date());
    const abbreviation = parts.find(part => part.type === 'timeZoneName')?.value ?? null;

    return abbreviation;
  } catch {
    return null;
  }
}
